const Event = require('./event');

/*
completions: function(part) -> string[]
ui:
	setAutocompleter(Autocomplete obj)
	show(list)
	hide()
	selectNext()
	selectPrevious()
	getSelected()
*/
class Autocomplete {
	constructor(ipt, opts){
		this.options = {
			completions: null,
			ui: null,
		};
		$.extend(this.options, opts);

		this.options.ui.setAutocompleter(this);

		this.input = ipt;
		this.toggled = false;

		$(ipt).keydown((e) => {
			switch(e.keyCode){
				case 13: // enter
				case 9: // tab
					if (this.toggled){
						let word = this.options.ui.getSelected();
						if (this.applyCompletion(word)){
							e.preventDefault();
							e.stopImmediatePropagation();
						}
					}
					break;

				case 38: // up
					if (this.toggled){
						e.preventDefault();
						this.options.ui.selectPrevious();
					}
					break;

				case 40: // down
					if (this.toggled){
						e.preventDefault();
						this.options.ui.selectNext();
					}
					break;
			}
		})
		.mouseup((e) => {
			this.findAndShowAutocompletions();
		})
		.blur((e) => {
			this.showAutocompletions([]);
		})
		.keyup((e) => {
			switch(e.keyCode){
				case 8: // backspace
				case 37: // left
				case 39: // right
					this.findAndShowAutocompletions();
					break;
			}
		})
		.on('input', (e) => {
			this.findAndShowAutocompletions();
		});
	}

	applyCompletion(word){
		let part = this.findCurrentWordPart();
		if (word.substr(0, part.length) == part){
			word = word.substr(part.length);
		}

		this.showAutocompletions([]);

		if (word == ''){
			return false;
		}

		this.input.setRangeText(word);
		this.input.selectionStart += word.length;

		return true;
	}

	resetCompletionsForm(){
		this.showAutocompletions([]);
	}

	findAndShowAutocompletions(){
		let words = this.findAutocompletions();
		this.showAutocompletions(words);
	}

	showAutocompletions(words){
		if (words.length > 0){
			this.options.ui.show(words);
			this.toggled = true;
		} else if (this.toggled){
			this.options.ui.hide();
			this.toggled = false;
		}
	}

	findAutocompletions(){
		let word = this.findCurrentWordPart();
		let words = this.options.completions(word);
		return words;
	}

	findCurrentWordPart(){
		let cnt = 0;
		let val = this.input.value;
		let start = this.input.selectionStart - 1;
		let i = start;

		if (start < 0){
			return '';
		}

		for (; cnt < 30 && i >= 0; --i){
			if (val[i] == ' ' || val[i] == '\t' || val[i] == '\n'){
				break;
			}
			++cnt;
		}
		++i;

		if (i <= start){
			return val.substr(i, start - i + 1);
		}

		return '';
	}
}

module.exports = Autocomplete;
